module.exports = __webpack_public_path__ + "static/media/Respiratory Papillomatosis.34a4140d.webp";